import { CIListFilter, MultiSelectDropdown } from 'ccs-ui-components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { REG_STATUS_TYPES, STATUS_LIST, STATUS_TYPES } from '../../constants';
import { statusList } from '../filter/Filter';

interface IAssociationFilterProps {
  queryParams: { [key: string]: string };
  setQueryParams: Dispatch<SetStateAction<{ [key: string]: string; }>>;
  isSourceSelected?: boolean
}

export const AssociationListFilter = ({ queryParams, setQueryParams, isSourceSelected = false }: IAssociationFilterProps) => {
  const { t: translate } = useTranslation();
  const [statusMultiFilterValue, setStatusMultiFilterValue] = useState<string[]>(queryParams.status ? queryParams.status.split(',') : []);
  const [selectAllOptions, setSelectAllOptions] = useState<boolean>(false);

  const statusTypes = [
    { value: STATUS_TYPES.ACTIVE, label: translate('event_filter.txt_active') },
    { value: STATUS_TYPES.INACTIVE, label: translate('event_filter.txt_inactive') },
    { value: STATUS_TYPES.DRAFT, label: translate('event_filter.txt_draft') },
    { value: STATUS_TYPES.READY_FOR_REVIEW, label: translate('event_filter.txt_panding_approval') },
    { value: STATUS_TYPES.RETURNED, label: translate('event_filter.txt_returned') }
  ];

  useEffect(() => {
    if (isSourceSelected) {
      setStatusMultiFilterValue((queryParams.status === '' || queryParams.status === undefined) ? STATUS_LIST : queryParams?.status?.split(','));
      setSelectAllOptions((queryParams?.status === '' || queryParams?.status === undefined) ? true : queryParams?.status?.split(',').length >= 2);
    } else {
      setStatusMultiFilterValue((queryParams.status === '' || queryParams.status === undefined) ? statusList : queryParams?.status?.split(','));
      setSelectAllOptions((queryParams?.status === '' || queryParams?.status === undefined) ? true : queryParams?.status?.split(',').length >= 5);
    }
  }, [queryParams]);

  /**
   * @method onClearHandler
   * @description Clears the page, item, and selected sort field.
   */
  const onClearHandler = () => {
    setQueryParams((pre: { [key: string]: string }) => ({
      ...pre,
      page: String(0),
      status: ''
    }));
  };

  // on Click of Apply Button
  const onApplyHandler = () => {
    setQueryParams((pre) => ({
      ...pre,
      status: selectAllOptions ? '' : statusMultiFilterValue.join(',') ?? '',
      page: String(0),
    }));
  };

  return (
    <CIListFilter applyEnabled onClear={onClearHandler} onApply={onApplyHandler}>
      <MultiSelectDropdown
        labelText={String(translate('source-topic-registry-filter.txt_status'))}
        options={isSourceSelected ? REG_STATUS_TYPES : statusTypes}
        selectedOptions={statusMultiFilterValue}
        onSelect={(e: string[]) => setStatusMultiFilterValue(e)}
        selectAll={selectAllOptions}
        handleSelectAll={(e: boolean) => setSelectAllOptions(e)}
        height="38px"
      />
      <div style={{ marginBottom: '32px' }} />
    </CIListFilter>

  );
};
